import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from "../../models/field.interface";
import { NgxImageCompressService } from 'ngx-image-compress';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteImageComponent } from '../../../delete-image/delete-image.component';
import * as _ from 'lodash';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import * as Compress from 'compress.js';
import { ImagePreviewComponent } from '../../../image-preview/image-preview.component';
import { RFFConstants } from '../../constants';
@Component({
  selector: 'app-unorderedlist',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description image-picker" *ngIf="field.style.visibility">
    <p>{{field.name}}<b *ngIf="field.validation.isRequired">*</b></p>
    <ng-container *ngIf="field.style.editability">
    <p class="max-image" *ngIf="!minimumFiveImage">You can upload max 1 File</p>
    <p class="max-image-red" *ngIf="minimumFiveImage">You can upload max 1 File</p>
    </ng-container>
    <div class="sameline-image" style="display: flex; align-items: center;" *ngFor='let file of field.value;let i=index'>
      <span>{{ file.file.name }}</span>
      <img class="img-cross" *ngIf="field.style.editability" (click)="deleteImage(i)" style="position: relative; margin: -10px 0px auto" src="assets/rff-images/remove-ic.svg">
    </div>
    <label *ngIf="(!field.value || field.value.length === 0) && field.style.editability" class="addfile" >
      <input type="file" (change)="onSelectFile($event)" accept=".jpg,.jpeg,.png,.gif,.svg,.mp3,.mpeg,.mp4,.mov,.xls,.xlsx,.csv,.doc,.docx,.pdf" class="media-file" #inputFile>
      <img src="assets/rff-images/add-img.svg" alt="add-img.svg" style="margin:0">
      <span>Add File</span>
    </label>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>    
    <span class="error-message" *ngIf="showError">Uploaded File should be less than 5 MB</span>    
    <span class="error-message" *ngIf="showTypeError">Sorry, the selected file type is not supported. Please choose a file of the following types: Images (JPEG, PNG, GIF, SVG), Audio (MP3), Video (MP4, MPEG, MOV), Excel (XLS, XLSX, CSV), Word (DOC, DOCX), PDF.</span> 
  </div>
</div>
`,
  styles: [`
.sameline-image {float: left;display: inline;margin-top:13px;margin-right: 20px;}
.img-cross{position: absolute;margin: -17px 47px auto}
.opacity{opacity : 0.3 ; pointer-events:none}`],
})
export class FilePickerComponent implements OnInit {
  field: FieldConfig;
  @ViewChild('inputFile') myInputVariable: ElementRef;
  group: FormGroup;
  minimumFiveImage = false;
  urls = [];
  popupImage = this.urls;
  deleteIndex;
  fieldArray: any;
  showError = false;
  date;
  location;
  imageSrc;
  showTypeError = false;
  constructor(
    private imageCompress: NgxImageCompressService,
    private modalService: NgbModal,
    private _validationService: ValidationService,
    private domSanitizer: DomSanitizer,
    private _constants: RFFConstants
  ) { }
  onSelectFile(event, image, orientation) {
    this.minimumFiveImage = false;
    if (event.target.files && event.target.files[0]) {
      let fileName = event.target.files[0].name;
      let filesAmount = event.target.files.length;
      if (filesAmount + this.urls.length <= 5) {
        if (filesAmount <= 1) {
          for (let i = 0; i < filesAmount; i++) {
            let file = event.target.files[i];
            if(!this._constants.ACCEPTING_FILE_MIME_TYPES.includes(file.type)) {
              this.showTypeError = true;
              return;
            } else if (file && file.size > (5 * 1000 * 1000)) {
              this.showError = true;
              return;
            } else {
              this.showError = false;
              this.showTypeError = false;
            }
            let reader = new FileReader();
            reader.onload = (event: Event) => {
              var img: any = new Image();
              const base64 = reader.result;

              function dataURLtoFile(result, filename) {
                var arr = result.split(','),
                  mime = arr[0].match(/:(.*?);/)[1],
                  bstr = atob(arr[1]),
                  n = bstr.length,
                  u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, { type: mime });
              }
              var file = dataURLtoFile(base64, fileName);

              const fileData = {
                file: file,
                thumb: base64
              }

              if (this.field.value === undefined || this.field.value.length === 0) {
                this.field.value = [];
              }

              this.field.value.push(fileData);
              console.log("FIELD VALUE", this.field.value);

              this.group.value[this.field.id] = this.field.value;
              const data = this.group.value;
              this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
              this.myInputVariable.nativeElement.value = '';
            };
            reader.readAsDataURL(file);
          };
        }
      } else {
        this.minimumFiveImage = true;
      }
    }
  }
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  showPosition(position) {
    this.date = 'Date: ' + moment().format('L') + ', Time: ' + moment(new Date()).format('LT');
    this.location = 'Location: ' + position.coords.latitude.toFixed(5) + ', ' + position.coords.longitude.toFixed(5);
  }
  ngOnInit() {
    if (this.field.value && this.field.value !== " ") {
      _.forEach(this.field.value, (thumb) => {
        // if (thumb.thumb) {
        //   thumb.src = thumb.thumb;
        //   this.urls.push(thumb);
        // } else {
        //   let perviewThumb = {
        //     src: this.getBase64String(thumb.thumbnail),
        //     thumb: this.getBase64String(thumb.thumbnail),
        //   }
        //   this.urls.push(perviewThumb);
        //   this.field.value = this.urls;
        // }
      })
    }
    if (this.field.value === undefined && this.field.value === " ") {
      this.field.value = [];
    }
    this.findMe();
  }
  
  deleteImage(i) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-small nested-modal',
    };
    const modalRef = this.modalService.open(DeleteImageComponent, modalOptions);
    modalRef.componentInstance.popupImage = this.popupImage;
    modalRef.componentInstance.deleteIndex = i;
    modalRef.componentInstance.fieldArray = this.field.value;
    modalRef.componentInstance.title = this.field.name;
    modalRef.componentInstance.message = `Are you sure want to delete the file: ${this.field.value[0].file.name}?`
    modalRef.componentInstance.filedValueLength = (data) => {
      this.field.value = undefined;
    };
  }
  openImage(img) {
    let modalOptions: any = {
      size: 'md',
      centered: true,
      windowClass: 'md-dialog-lg light-modal',
    };
    const modalRef = this.modalService.open(ImagePreviewComponent, modalOptions);
    modalRef.componentInstance.imageSrc = img;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/file/file.component.ts